/*
|--------------------------------------------------------------------------
| GENERATE SLUG
|--------------------------------------------------------------------------
*/

export const generateSlug = (value) => {
  if (!value) {
    return "";
  }

  return value
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};


/*
|--------------------------------------------------------------------------
| NORMALIZE NAME
|--------------------------------------------------------------------------
*/

export const normalizeName = (name) => {
  if (!name) {
    return "";
  }

  return name
    .trim()
    .replace(/\s+/g, " ");
};


/*
|--------------------------------------------------------------------------
| NORMALIZE SLUG
|--------------------------------------------------------------------------
*/

export const normalizeSlug = (slug) => {
  return generateSlug(slug);
};